<template>
  <div class="print-view-btn">
    <el-dropdown v-if="isList || isSub || allowLabelPrint" @command="handleCommand">
      <el-button
        type=""
        icon="el-icon-printer"
        :size="size"
        :loading="labelLoading"
        style="background-color: #fff; border-color: #e6a23c; color: #e6a23c"
      >
        {{ btnTag }}<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :command="btnTag">{{ btnTag }}</el-dropdown-item>
        <el-dropdown-item v-if="isList" :command="groupBtnTag">{{ groupBtnTag }}</el-dropdown-item>
        <el-dropdown-item v-if="isSub" :command="supBtnTag">{{ supBtnTag }}</el-dropdown-item>
        <el-dropdown-item v-if="allowLabelPrint" :command="'label'">标签打印</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-button
      v-else
      type="primary"
      @click="printBtnClickEvent"
      icon="el-icon-printer"
      :size="size"
      style="background-color: #fff; color: #E6A23C; border-color: #E6A23C;"
    >{{ btnTag }}</el-button>

    <printLabelQty
      v-if="allowLabelPrint"
      :visible.sync="showLabelPrint"
      :changeList="labelSourceList"
      :labelType="labelPrintType"
      :modules="modules"
      @confirm="onLabelPrintConfirm"
    />

    <printViewFun
      :showprint="showprint"
      :groupGet="labelPrintActive ? false : group"
      :filterList="filterList"
      :filterKey="filterKey"
      :supGet="labelPrintActive ? false : sup"
      :supKey="supKey"
      :changeList="activeChangeList"
      @close="onPrintClose"
      :modules="modules"
      v-if="showprint"
      :printFun="activePrintFun"
      :printTitle="printTitle"
      :groupPrintFun="groupPrintFun"
      :printDragType="printDragType"
      :printDragUrl="printDragUrl"
      :printDragIdList="printDragIdList"
      :printOrderName="printOrderName"
      :printDetailParamName="printDetailParamName"
      :printDetailParamValue="printDetailParamValue"
      :presetTemplateDetails="activePresetTemplateDetails"
      :presetTemplateId="activePresetTemplateId"
      :skipPicker="labelPrintActive"
      @handleAvatarChange="handleAvatarChange"
      @handleAvatarSuccess="handleAvatarSuccess"
    ></printViewFun>
  </div>
</template>

<script>
import printLabelQty from '@/components/print/printLabelQty.vue';
import { fetchLabelPrintRows, normalizeLabelProductRow } from '@/utils/printLabelRows';

export default {
  components: { printLabelQty },
  props: {
    printTitle: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'small'
    },
    isList: {
      type: Boolean,
      default: false
    },
    isSub: {
      type: Boolean,
      default: false
    },
    supKey: {
      type: String,
      default: 'table'
    },
    btnTag: {
      type: String,
      default: '打印'
    },
    groupPrintFun: {
      type: Function,
      default: null
    },
    groupBtnTag: {
      type: String,
      default: '组打印'
    },
    supBtnTag: {
      type: String,
      default: '明细打印'
    },
    modules: {
      type: Number,
      default: 0
    },
    filterList: {
      type: Array,
      default() {
        return [];
      }
    },
    filterKey: {
      type: String,
      default: ''
    },
    changeList: {
      type: Array,
      default() {
        return [];
      }
    },
    printFun: {
      type: Function,
      default: null
    },
    printDragType: {
      type: String,
      default: null
    },
    printDragUrl: {
      type: String,
      default: null
    },
    printDragIdList: {
      type: Array,
      default() {
        return [];
      }
    },
    printOrderName: {
      type: String,
      default: null
    },
    printDetailParamName: {
      type: String,
      default: null
    },
    printDetailParamValue: {
      type: String,
      default: null
    },
    allowLabelPrint: {
      type: Boolean,
      default: false
    },
    labelPrintType: {
      type: String,
      default: 'product'
    }
  },
  data() {
    return {
      title: '',
      showprint: false,
      group: false,
      sup: false,
      showLabelPrint: false,
      labelPrintActive: false,
      labelPrintList: [],
      labelSourceList: [],
      labelPresetTemplateDetails: null,
      labelPresetTemplateId: null,
      labelLoading: false
    };
  },
  computed: {
    activeChangeList() {
      return this.labelPrintActive && this.labelPrintList.length
        ? this.labelPrintList
        : this.changeList;
    },
    activePrintFun() {
      return this.labelPrintActive ? null : this.printFun;
    },
    activePresetTemplateDetails() {
      return this.labelPrintActive && this.labelPresetTemplateDetails
        ? this.labelPresetTemplateDetails
        : null;
    },
    activePresetTemplateId() {
      return this.labelPrintActive && this.labelPresetTemplateId
        ? this.labelPresetTemplateId
        : null;
    }
  },
  methods: {
    handleCommand(command) {
      if (command === 'label' || command === '标签打印') {
        this.openLabelPrint();
        return;
      }
      switch (command) {
        case this.btnTag:
          if (this.printTitle) {
            this.printTitle = '' + this.printTitle;
          }
          this.printBtnClickEvent();
          break;
        case this.groupBtnTag:
          if (this.printTitle) {
            this.title = this.printTitle + ' ';
          }
          this.printTitle = '';
          this.printGroupBtnClickEvent();
          break;
        case this.supBtnTag:
          this.printSupBtnClickEvent();
          break;
        default:
          break;
      }
    },
    printBtnClickEvent() {
      this.sup = false;
      this.group = false;
      this.toprint();
    },
    printGroupBtnClickEvent() {
      this.sup = false;
      this.group = true;
      this.toprint();
    },
    printSupBtnClickEvent() {
      this.sup = true;
      this.group = false;
      this.toprint();
    },
    toprint() {
      if (!this.changeList || this.changeList.length === 0) {
        this.$message.error('请先选择数据');
        return;
      }
      this.labelPrintActive = false;
      this.labelPrintList = [];
      this.labelPresetTemplateDetails = null;
      this.labelPresetTemplateId = null;
      if (this.showprint) {
        this.showprint = false;
        this.$nextTick(() => {
          this.showprint = true;
        });
        return;
      }
      this.showprint = true;
    },
    openLabelPrint() {
      if (!this.changeList || this.changeList.length === 0) {
        this.$message.error('请先选择数据');
        return;
      }
      this.labelSourceList = this.changeList.map((row) =>
        normalizeLabelProductRow(row, this.modules)
      );
      this.showLabelPrint = true;
      this.refreshLabelRows();
    },
    async refreshLabelRows() {
      if (!this.printFun) return;
      this.labelLoading = true;
      try {
        const rows = await fetchLabelPrintRows({
          changeList: this.changeList,
          printFun: this.printFun,
          modules: this.modules
        });
        if (rows.length && this.showLabelPrint) {
          this.labelSourceList = rows;
        }
      } catch (e) {
        /* 详情失败时继续用列表行，不挡住弹窗 */
      } finally {
        this.labelLoading = false;
      }
    },
    onLabelPrintConfirm() {
      // 标签打印已在向导内直接打开预览，不再走「选择模板」
      this.showLabelPrint = false;
      this.showprint = false;
      this.labelPrintActive = false;
      this.labelPrintList = [];
      this.labelPresetTemplateDetails = null;
      this.labelPresetTemplateId = null;
    },
    onPrintClose() {
      this.showprint = false;
      this.labelPrintActive = false;
      this.labelPrintList = [];
      this.labelPresetTemplateDetails = null;
      this.labelPresetTemplateId = null;
    },
    handleAvatarSuccess(res, file) {
      this.$emit('handleAvatarSuccess', res, file);
    },
    handleAvatarChange(file, fileList) {
      this.$emit('handleAvatarChange', file);
    }
  }
};
</script>

<style scoped>
.print-view-btn {
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
}
.e-pr {
  width: 100%;
  top: 20%;
}
</style>
